import { SHADOW_BASE_SPREAD_DEFINITION } from './core.js';
import { createSpreadDefinition } from '../internal/builders.js';
export const STESA_OMBRA_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'stesa-ombra',
    name: 'Stesa Ombra',
    slug: 'stesa-ombra',
    category: 'special',
    description: 'Cinque carte per riconoscere ombra, desiderio, attrito e direzione di integrazione.',
    ritual_note: 'Accosta la lettura con ritmo lento e senza cercare assoluzioni immediate.',
    opening_invocation: 'Scendo nel materiale che evito e gli concedo una lingua onesta.',
    closing_words: 'Risalgo con ciò che posso sostenere e lascio il resto sedimentare.',
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['shadow', 'healing'],
    semantic_tags: ['shadow-work', 'introspective', 'healing'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'shadow', description: 'Quale ombra chiede di essere riconosciuta?' },
        { role_id: 'desire', description: 'Quale desiderio la alimenta o la nasconde?' },
        { role_id: 'challenge', description: 'Quale attrito impedisce la visione limpida?' },
        { role_id: 'truth', description: 'Quale verità sta tentando di emergere?' },
        { role_id: 'integration', description: 'Come può essere accolto il materiale senza drammatizzarlo?' },
    ],
    keywords: ['ombra', 'desiderio', 'verità', 'integrazione'],
    recommended_for_questions: [
        'Che cosa sto rimuovendo e come posso guardarlo senza cedere al fatalismo?',
        'Quale verità interiore sto evitando di nominare?',
    ],
    contraindications: ['Non ideale per domande puramente logistiche o tecniche.'],
    focus_mode_ids: ['shadow-descent'],
    ritual_intensity: 3,
});
export const GUARIGIONE_INTERIORE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'guarigione-interiore',
    name: 'Guarigione Interiore',
    slug: 'guarigione-interiore',
    category: 'special',
    description: 'Sei posizioni per ferita, sostegno, gesto di cura e integrazione sostenibile.',
    ritual_note: 'Meglio praticarla quando puoi annotare sensazioni, resistenze e immagini emergenti.',
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'grid',
    intent: ['healing', 'shadow'],
    semantic_tags: ['healing', 'shadow-work', 'introspective'],
    layout_id: 'custom-grid-6',
    position_specs: [
        { role_id: 'wound', description: 'Quale ferita chiede ascolto?' },
        { role_id: 'hidden', description: 'Che cosa rimane ancora non detto?' },
        { role_id: 'resource', description: 'Quale risorsa è già disponibile?' },
        { role_id: 'action', description: 'Quale micro-azione può sostenere il processo?' },
        { role_id: 'ritual_action', description: 'Quale gesto simbolico aiuta la cura?' },
        { role_id: 'integration', description: 'Che forma di integrazione è realistica ora?' },
    ],
    keywords: ['cura', 'ferita', 'risorsa', 'integrazione'],
    recommended_for_questions: [
        'Di che tipo di cura ho davvero bisogno?',
        'Come posso sostenere un processo di guarigione senza forzarlo?',
    ],
    contraindications: ['Non usarla come sostituto di supporto clinico o professionale.'],
    focus_mode_ids: ['shadow-healing-window'],
    ritual_intensity: 3,
});
export const CATENA_FERITA_POTERE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'catena-ferita-potere',
    name: 'Catena / Ferita / Potere',
    slug: 'catena-ferita-potere',
    category: 'special',
    description: 'Triade essenziale per leggere vincolo, lesione e forza trattenuta.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'cross',
    intent: ['shadow', 'healing', 'lilith'],
    semantic_tags: ['shadow-work', 'healing', 'initiatic'],
    layout_id: 'crossed-3',
    position_specs: [
        { role_id: 'chain', description: 'Quale catena o schema ti tiene fermo?' },
        { role_id: 'wound', description: 'Quale ferita lo alimenta?' },
        { role_id: 'repressed_power', description: 'Quale forza nascosta può invertire il pattern?' },
    ],
    keywords: ['catena', 'ferita', 'potere', 'triade'],
    recommended_for_questions: [
        'Perché ripeto sempre lo stesso nodo?',
        'Quale potenza sto trattenendo sotto una vecchia ferita?',
    ],
    contraindications: ['Non ideale per domande che chiedono un quadro temporale ampio.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const DISCESA_INTEGRAZIONE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'discesa-integrazione',
    name: 'Discesa e Integrazione',
    slug: 'discesa-integrazione',
    category: 'special',
    description: 'Sette carte per una discesa controllata: superficie, ombra, ferita, catena, verità, gesto e integrazione.',
    ritual_note: 'È una stesa profonda: usala quando puoi restare in ascolto e non per curiosità impulsiva.',
    opening_invocation: 'Discendo senza violenza, osservo senza censura, risalgo con discernimento.',
    closing_words: 'Integro solo ciò che può farsi forma adesso.',
    difficulty: 'advanced',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'horseshoe',
    intent: ['shadow', 'healing', 'lilith'],
    semantic_tags: ['shadow-work', 'initiatic', 'healing'],
    layout_id: 'horseshoe-7',
    position_specs: [
        { role_id: 'mask', description: 'Quale superficie stai mostrando?' },
        { role_id: 'shadow', description: 'Che cosa vive appena sotto?' },
        { role_id: 'wound', description: 'Quale ferita apre la discesa?' },
        { role_id: 'chain', description: 'Quale legame o schema mantiene il ciclo?' },
        { role_id: 'truth', description: 'Quale verità emerge dal fondo?' },
        { role_id: 'ritual_action', description: 'Quale gesto sostiene il ritorno?' },
        { role_id: 'integration', description: 'Che cosa può essere integrato senza eccesso?' },
    ],
    keywords: ['discesa', 'integrazione', 'ombra', 'iniziatico'],
    recommended_for_questions: [
        'Sono pronto a vedere il pattern nella sua interezza?',
        'Quale verità si trova sotto il mio copione abituale?',
    ],
    contraindications: ['Non ideale come prima stesa se il consultante cerca solo orientamento rapido.'],
    focus_mode_ids: ['shadow-integration'],
    ritual_intensity: 4,
});
export const SHADOW_SPREAD_DEFINITIONS = [
    SHADOW_BASE_SPREAD_DEFINITION,
    STESA_OMBRA_SPREAD_DEFINITION,
    GUARIGIONE_INTERIORE_SPREAD_DEFINITION,
    CATENA_FERITA_POTERE_SPREAD_DEFINITION,
    DISCESA_INTEGRAZIONE_SPREAD_DEFINITION,
];
//# sourceMappingURL=shadow.js.map